import { render } from "./Modal.vue?vue&type=template&id=820f08f6&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=820f08f6&scoped=true&lang=css"

import exportComponent from "E:\\Data\\Repos\\Propnroll\\Propnroll\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-820f08f6"]])

export default __exports__